import { render } from "./MainPageLayout.vue?vue&type=template&id=dcda9a56&scoped=true"
import script from "./MainPageLayout.vue?vue&type=script&lang=js"
export * from "./MainPageLayout.vue?vue&type=script&lang=js"

import "./MainPageLayout.vue?vue&type=style&index=0&id=dcda9a56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcda9a56"]])

export default __exports__